export const data = {
  episode: 3,
  title: "Night Journey & Ascension to Heavens 2",
  video: "https://www.youtube.com/watch?v=128GJfzeMwI",
};
